import {
  addDoc,
  collection,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  setDoc,
} from "firebase/firestore";
import { auth, db } from "../../../../backend/firebaseConfig";

const adviserCatchUpDataRef = (adviserId) =>
  doc(
    db,
    "Authorized Members",
    "Advisers",
    "Data",
    adviserId,
    "Catch Up",
    "Data",
  );

const catchUpsRef = (adviserId) =>
  collection(
    db,
    "Authorized Members",
    "Advisers",
    "Data",
    adviserId,
    "Catch Up",
    "Data",
    "Details",
  );

const currentIso = () => new Date().toISOString();

const normaliseEmail = (value) => String(value || "").trim().toLowerCase();

const toPointOfContactRecord = (email) => ({
  email: normaliseEmail(email),
});

export const subscribeAdviserCatchUpData = (adviserId, callback) => {
  if (!adviserId || typeof callback !== "function") return () => {};

  return onSnapshot(adviserCatchUpDataRef(adviserId), (snapshot) => {
    callback(snapshot.exists() ? snapshot.data() : {});
  });
};

export const getAdviserCatchUpAssignmentData = async (adviserId) => {
  if (!adviserId) return {};
  const snapshot = await getDoc(adviserCatchUpDataRef(adviserId));
  return snapshot.exists() ? snapshot.data() : {};
};

export const subscribeCatchUps = (adviserId, callback) => {
  if (!adviserId || typeof callback !== "function") return () => {};

  const catchUpsQuery = query(catchUpsRef(adviserId), orderBy("createdAt", "desc"));

  return onSnapshot(catchUpsQuery, (snapshot) => {
    callback(
      snapshot.docs.map((entry) => ({
        id: entry.id,
        ...entry.data(),
      })),
    );
  });
};

export const saveAdviserCatchUpPointOfContact = async (
  adviserId,
  assignedEmails = [],
  primaryEmail = "",
) => {
  if (!adviserId) throw new Error("Adviser id is required.");

  const uniqueAssignedEmails = Array.from(
    new Set(assignedEmails.map(normaliseEmail).filter(Boolean)),
  );
  const selectedPrimaryEmail = normaliseEmail(primaryEmail);

  if (!uniqueAssignedEmails.length) {
    throw new Error("Select at least one point of contact.");
  }

  if (!selectedPrimaryEmail || !uniqueAssignedEmails.includes(selectedPrimaryEmail)) {
    throw new Error("Select one assigned point of contact as the primary point of contact.");
  }

  const now = currentIso();
  const user = auth.currentUser;
  const assignedStaff = uniqueAssignedEmails.map(toPointOfContactRecord);
  const primaryPointOfContact = toPointOfContactRecord(selectedPrimaryEmail);

  await setDoc(
    adviserCatchUpDataRef(adviserId),
    {
      assignedStaff,
      primaryPointOfContact,
      updatedAt: now,
      updatedBy: {
        name: user?.displayName || user?.email || "Unknown user",
        email: user?.email || "",
        uid: user?.uid || "",
      },
    },
    { merge: true },
  );
};

export const saveAdviserCatchUpPrimaryContact = (adviserId, email) =>
  saveAdviserCatchUpPointOfContact(adviserId, [email], email);

export const addCatchUpEntry = async (adviserId, { catchUpAt, notes }) => {
  if (!adviserId) throw new Error("Adviser id is required.");

  const catchUpDate = new Date(catchUpAt);
  if (Number.isNaN(catchUpDate.getTime())) {
    throw new Error("Enter a valid Catch Up date and time.");
  }
  const catchUpIso = catchUpDate.toISOString();

  const now = currentIso();
  const user = auth.currentUser;
  const userEmail = user?.email || "";

  await addDoc(catchUpsRef(adviserId), {
    addedBy: user?.displayName || userEmail || "Unknown user",
    addedByEmail: userEmail,
    addedByUid: user?.uid || "",
    catchUpAt: catchUpIso,
    notes: String(notes || "").trim(),
    createdAt: now,
    updatedAt: now,
  });
};
